import { Widget, WidgetProps } from "@rjsf/core";

import { FormMessage, Radio } from "@xometry/xometry_loft";

import { MarketplaceOptionGridType } from "../../../schema/generated/schema";
import { getEnumOptions } from "../utils";

import { LabelWithOptionalFlag } from "./LabelWithOptionalFlag";
import { Section, RadioGroup } from "./Shared.style";

export const LoftRadioField: Widget = ({
  disabled,
  onChange,
  options,
  rawErrors,
  required,
  schema,
  value,
  uiSchema,
}: WidgetProps) => {
  const isInvalid = !!(rawErrors?.length > 0 && options?.touched);
  const enumOptions = getEnumOptions(schema, options);

  let gridCSS = "auto auto";
  if (options.grid === MarketplaceOptionGridType.OneCol) {
    gridCSS = "1fr";
  } else if (options.grid === MarketplaceOptionGridType.TwoCol) {
    gridCSS = "1fr 1fr";
  } else if (options.grid === MarketplaceOptionGridType.ThreeCol) {
    gridCSS = "1fr 1fr 1fr";
  }

  return (
    <div css={Section}>
      <LabelWithOptionalFlag
        required={required}
        htmlFor={options?.name as string}
        tooltip={(options?.tooltip || "") as string}
      >
        {schema.title}
      </LabelWithOptionalFlag>
      <div css={[RadioGroup, `grid-template-columns: ${gridCSS}`]}>
        {enumOptions?.map(opt => {
          return (
            <div key={opt.value as string}>
              <Radio
                defaultChecked={value === opt.value}
                disabled={disabled}
                name={schema.title}
                value={opt.value as string}
                id={opt?.value as string}
                key={opt?.value as string}
                scale="small"
                enterKeyHint="Radio"
                onChange={event => {
                  event.stopPropagation();
                  const isChecked = !!event.currentTarget?.checked;
                  if (isChecked) {
                    onChange(opt.value);
                  }
                }}
              />
              <label htmlFor={opt.value}>{opt.label}</label>
            </div>
          );
        })}
      </div>
      {uiSchema?.description && (
        <FormMessage>{uiSchema.description}</FormMessage>
      )}
      {isInvalid && (
        <FormMessage invalid>{rawErrors ? rawErrors[0] : ""}</FormMessage>
      )}
    </div>
  );
};
